import { ref, watch } from 'vue';
import Notify from 'quasar/src/plugins/Notify.js';;
import axios from 'axios';

const xios = axios.create({
  // baseURL: 'http://localhost:7757',
  baseURL: 'https://api.igeotechgps.com',
});

export const currentModel = ref({});
// watch(
//   currentModel,
//   (v) => {
//     console.log(v);
//   },
//   { deep: true },
// );
export function getNestedProperty(obj, path) {
  let keys = path.split('.');
  let current = obj;

  for (let key of keys) {
    if (current[key] !== undefined) {
      current = current[key];
    } else {
      return undefined; // Property not found
    }
  }

  return current;
}

export function mutateStringPath(obj, path, v) {
  const keys = typeof path === 'string' ? path.split('.') : path;
  // console.log(obj, path, v);
  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = v;
    } else {
      if (!acc[key]) {
        acc[key] = {};
      }
      return acc[key];
    }
  }, obj);
}

export async function submitForm(model, userInfo) {
  if (model == 'Booking') {
    if (currentModel.value.assignedDriver) {
      currentModel.value.trips.forEach((trip) => {
        trip.driverId = currentModel.value.assignedDriver.id;
      });
    }
  }
  try {
    const res = await xios.post('api-tms/script-insert-standard', {
      model,
      options: { ...currentModel.value, clientId: userInfo.uid },
      // {
      //   firstName: 'Johnz',
      //   lastName: 'Doez',
      //   username: 'johndoe123z',
      //   email: 'john.does123z@example.com',
      //   phone: '+60123456789',
      //   dateOfBirth: '1990-01-15',
      //   gender: 'Male',
      //   licenseNumber: 'DL12345673389asdaz',
      //   licenseExpiry: '2025-12-31',
      //   licenseType: 'Commercial',
      //   truckType: 'Box',
      //   preferredVehicle: 'Truck',
      //   password: 'securePassword123',
      //   clientId: 1,
      //   status: 1,
      //   meta: {
      //     address: {
      //       street: '123 Main Street',
      //       city: 'Kuala Lumpur',
      //       state: 'WP',
      //       postalCode: '50000',
      //       country: 'Malaysia',
      //     },
      //     emergencyContact: {
      //       name: 'Jane Doe',
      //       phone: '+60123456780',
      //     },
      //     paymentDetails: {
      //       accountNumber: '1234567890',
      //       bankName: 'Malaysia Bank',
      //     },
      //     bloodType: 'O+',
      //     notes: 'Experienced driver with 5+ years in logistics',
      //   },
      // },
    });

    if (res.data.success) {
      Notify.create({
        message: `${model} created successfully!`,
        classes: 'bg-green px-4',
      });
    } else {
      Notify.create({
        message: res.data.error.message,
        classes: 'bg-red px-4',
      });
    }
  } catch (error) {
    console.log(error);

    Notify.create({
      message: error.response.data.error.details[0],
      classes: 'bg-red px-4',
    });
  }
}
